/**
 * @file Header
 */

/**
 * Header component
 */
const vHeader = () => {
	const header = document.querySelector( '.v-header' );

	if (
		! header ||
		! wpPostData.is_front_page
	) {
		return;
	}

	const navWrap = document.querySelector( '.v-header__navigation-wrap-home' );
	const query   = window.matchMedia( '(min-height: 600px)' );
	/**
	 * Adjusts the custom property for slider height based on browser height
	 */
	const setSliderHeight = () => {
		const sliderHeight = query.matches ? '100vh' : '560px';
		navWrap.style.setProperty( '--slider-height', sliderHeight );
	};
	query.addEventListener( 'change', setSliderHeight );
	setSliderHeight();
};

export default vHeader;
